import React from 'react';
import { string } from 'prop-types';

import Spinner from './Spinner';
import Block from './Block';

import './LoadingIndicator.scss';

const LoadingIndicator = ({ label }) => (
  <div className="result-list-view-spinner">
    <Block>
      <Spinner
        primary
        medium
        text={label}
      />
    </Block>
  </div>
);

LoadingIndicator.propTypes = {
  label: string,
};

LoadingIndicator.defaultProps = {
  label: '',
};

export default LoadingIndicator;
